import Cookies from "universal-cookie";
import { OrderItem } from "../features/Order/interfaces/order.interface";

const cookies = new Cookies();
const CART_COOKIE_KEY = "cart_items";

export const saveCartItems = (items: OrderItem[]): void => {
  cookies.set(CART_COOKIE_KEY, items, { path: "/", maxAge: 3600 });
};

export const getCartItems = (): OrderItem[] => {
  const value = cookies.get<OrderItem[]>(CART_COOKIE_KEY);
  return Array.isArray(value) ? value : [];
};

export const parseItemsFromUrl = (search: string): OrderItem[] => {
  const params = new URLSearchParams(search);
  const map: Record<number, Partial<OrderItem>> = {};

  params.forEach((value, key) => {
    const match = /^items\[(\d+)\]\[([nqp])\]$/.exec(key);
    if (!match) return;
    const index = Number.parseInt(match[1], 10);
    const field = match[2];
    if (!map[index]) map[index] = {};
    if (field === "n") map[index].productName = value;
    if (field === "q") map[index].quantity = Number.parseInt(value, 10);
    if (field === "p") map[index].unitPrice = Number.parseFloat(value);
  });

  return Object.values(map).filter(
    (item): item is OrderItem => !!item.productName && typeof item.quantity === "number"
  );
};
